(function () {
  document.querySelectorAll('[data-embed-live]').forEach(function (root) {
    var id = root.getAttribute('data-organizer-id');
    var main = root.querySelector('.pp-embed__main');
    var off = root.querySelector('.pp-embed__offseason');
    var done = false;
    function finish(empty) {
      if (done) return;
      done = true;
      root.classList.remove('is-checking');
      if (empty && off) {
        if (main) main.hidden = true;
        off.hidden = false;
        root.classList.add('is-offseason');
      }
    }
    setTimeout(function () { finish(false); }, 3500);
    fetch('https://shotgun.live/api/data/organizers/' + encodeURIComponent(id) + '/events-listing-widget')
      .then(function (r) { return r.ok ? r.json() : Promise.reject(r.status); })
      .then(function (data) {
        var now = Date.now() / 1000;
        var upcoming = (data.events || []).filter(function (e) { return e.endTime > now; });
        finish(upcoming.length === 0);
      })
      .catch(function () { finish(false); });
  });
})();
